export const authConfigExternal = {
    loginEndpoint: process.env.GATSBY_AUTH_LOGIN_ENDPOINT,
    tokenEndpoint: process.env.GATSBY_EXTERNAL_TOKEN_ENDPOINT,
    userEndpoint: process.env.GATSBY_EXTERNAL_USER_ENDPOINT,
    clientId: process.env.GATSBY_AUTH_CLIENT_ID,
    responseType: "code",
    scopes: [
      "aws.cognito.signin.user.admin",
      "email",
      "openid",
      "phone",
      "profile",
    ],
    redirectUri: process.env.GATSBY_AUTH_REDIRECT_URI,
  };
  
  export const authConfigInternal = {
    loginEndpoint: process.env.GATSBY_AUTH_LOGIN_ENDPOINT,
    clientId: process.env.GATSBY_AUTH_CLIENT_ID,
    responseType: "code",
    scopes: [
      "aws.cognito.signin.user.admin",
      "email",
      "openid",
      "phone",
      "profile",
    ],
    redirectUri: process.env.GATSBY_AUTH_REDIRECT_URI,
  };